// src/App.js
import React, { useState, useEffect, useMemo, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, Link as RouterLink } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaWhatsapp } from "react-icons/fa";
import { FiMenu, FiX } from "react-icons/fi";

// Components
import TestimonialSlider from "./components/TestimonialSlider.jsx";
import SubcategoryPage from "./components/SubcategoryPage.js";
import ProductDetailPage from "./components/ProductDetailPage.js";
import Gallery from "./components/Gallery.js";
import "./App.css";

// Pages
import DecorZoomStore from "./pages/DecorZoomStore.js";
import StoreProductDetail from "./pages/StoreProductDetail.js";
import CartPage from "./pages/CartPage.js";
import Checkout from "./pages/Checkout.js";
import BirthdayDecorationDelhiPage from "./pages/BirthdayDecorationDelhiPage.js";
import BirthdayDecorationGhaziabadPage from "./pages/BirthdayDecorationGhaziabadPage.js";
import BirthdayDecorationNoidaPage from "./pages/BirthdayDecorationNoidaPage.js";
import FirstBirthdayDecorationDelhiPage from "./pages/FirstBirthdayDecorationDelhiPage.js";
import BabyShowerDecorationDelhiPage from "./pages/BabyShowerDecorationDelhiPage.js";
import BalloonDecorationDelhiPage from "./pages/BalloonDecorationDelhiPage.js";
import BirthdayDecorationGurgaonPage from "./pages/BirthdayDecorationGurgaonPage.js";
import BirthdayDecorationFaridabadPage from "./pages/BirthdayDecorationFaridabadPage.js";
import BalloonDecorationGhaziabadPage from "./pages/BalloonDecorationGhaziabadPage.js";
import BalloonDecorationNoidaPage from "./pages/BalloonDecorationNoidaPage.js";
import WelcomeBabyDecorationDelhiPage from "./pages/WelcomeBabyDecorationDelhiPage.js";
import WelcomeBabyDecorationGhaziabadPage from "./pages/WelcomeBabyDecorationGhaziabadPage.js";
import WelcomeBabyDecorationNoidaPage from "./pages/WelcomeBabyDecorationNoidaPage.js";
import BalloonDecorationGurgaonPage from "./pages/BalloonDecorationGurgaonPage.js";
import BalloonDecorationFaridabadPage from "./pages/BalloonDecorationFaridabadPage.js";
import AnniversaryDecorationDelhiPage from "./pages/AnniversaryDecorationDelhiPage.js";
import AnniversaryDecorationGhaziabadPage from "./pages/AnniversaryDecorationGhaziabadPage.js";
import AnniversaryDecorationNoidaPage from "./pages/AnniversaryDecorationNoidaPage.js";
import BrideToBeDecorationDelhiPage from "./pages/BrideToBeDecorationDelhiPage.js";
import JungleThemeDecorationDelhiPage from "./pages/JungleThemeDecorationDelhiPage.js";
import BarbieThemeDecorationDelhiPage from "./pages/BarbieThemeDecorationDelhiPage.js";
import CocomelonThemeDecorationDelhiPage from "./pages/CocomelonThemeDecorationDelhiPage.js";
import BossBabyThemeDecorationDelhiPage from "./pages/BossBabyThemeDecorationDelhiPage.js";
import UnicornThemeDecorationDelhiPage from "./pages/UnicornThemeDecorationDelhiPage.js";
import ButterflyThemeDecorationDelhiPage from "./pages/ButterflyThemeDecorationDelhiPage.js";
import SpidermanThemeDecorationDelhiPage from "./pages/SpidermanThemeDecorationDelhiPage.js";
import MickeyMouseThemeDecorationDelhiPage from "./pages/MickeyMouseThemeDecorationDelhiPage.js";
import DecorationAllahabadPage from "./pages/DecorationAllahabadPage.js";
import BanquetsPage from "./pages/BanquetsPage.jsx";
import BanquetDetailPage from "./pages/BanquetDetailPage.jsx";
import SamplePublicBanquetDetailPage from "./pages/SamplePublicBanquetDetailPage.jsx";
import BanquetOwnerLoginPage from "./features/banquetOwnerPanel/pages/BanquetOwnerLoginPage.jsx";
import BanquetOwnerDashboardPage from "./features/banquetOwnerPanel/pages/BanquetOwnerDashboardPage.jsx";
import OwnerFillFormPage from "./features/banquetOwnerPanel/pages/OwnerFillFormPage.jsx";
import BanquetOwnerProtectedRoute from "./features/banquetOwnerPanel/components/BanquetOwnerProtectedRoute.jsx";
import SuperAdminProtectedRoute from "./features/banquetOwnerPanel/components/SuperAdminProtectedRoute.jsx";
import SuperAdminBanquetOwnersPage from "./features/banquetOwnerPanel/pages/SuperAdminBanquetOwnersPage.jsx";
import SuperAdminBanquetReviewPage from "./features/banquetOwnerPanel/pages/SuperAdminBanquetReviewPage.jsx";
import SuperAdminQuickAddBanquetPage from "./features/banquetOwnerPanel/pages/SuperAdminQuickAddBanquetPage.jsx";
import HomePagePreview from "./pages/HomePagePreview.jsx";
import { allSeoLandingLinks } from "./data/seoLandingPages.js";

// ---------------- NAVBAR (Bina Chheda-Chhaadi) ----------------
export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [banquetsMenuOpen, setBanquetsMenuOpen] = useState(false);
  const banquetsDropdownRef = useRef(null);
  const navigate = useNavigate();
  const banquetMenuItems = [
    { label: "Explore Banquets", href: "/banquets" },
    { label: "Search Your Banquet", href: "/banquets" },
    { label: "Banquet Login", href: "/banquet-owner/login?type=banquet" },
    { label: "Super Admin", href: "/banquet-owner/login?type=admin" },
  ];
  const toggleMenu = () => {
    setMenuOpen((value) => {
      if (value) {
        setBanquetsMenuOpen(false);
      }
      return !value;
    });
  };
  const openBanquetMenuItem = (event, href) => {
    event.preventDefault();
    event.stopPropagation();
    setBanquetsMenuOpen(false);
    setMenuOpen(false);
    navigate(href);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (banquetsDropdownRef.current && !banquetsDropdownRef.current.contains(event.target)) {
        setBanquetsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setBanquetsMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-green-600">DecorZoom</h1>
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-2xl text-gray-700">
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
        <nav className="hidden md:flex items-center space-x-6">
          {["Home", "About", "Services", "Gallery", "Contact"].map((text) => (
            <a key={text} href={`#${text.toLowerCase()}`} className="hover:text-pink-600 font-medium text-lg">{text}</a>
          ))}
          <div
            ref={banquetsDropdownRef}
            className="relative"
            onMouseEnter={() => setBanquetsMenuOpen(true)}
          >
            <button
              type="button"
              onClick={() => setBanquetsMenuOpen((value) => !value)}
              className="rounded-full bg-emerald-600 px-4 py-2 font-medium text-white transition hover:bg-emerald-700"
              aria-expanded={banquetsMenuOpen}
              aria-haspopup="menu"
            >
              Banquets ▼
            </button>
            {banquetsMenuOpen ? (
              <div className="absolute right-0 top-full z-[80] w-60 pt-2">
                <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white py-2 shadow-xl">
                  {banquetMenuItems.map((item) => (
                    <a
                      key={item.label}
                      href={item.href}
                      className="block min-h-[44px] touch-manipulation px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-emerald-50 hover:text-emerald-700"
                      onClick={(event) => openBanquetMenuItem(event, item.href)}
                      onTouchEnd={(event) => openBanquetMenuItem(event, item.href)}
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </nav>
      </div>
      {menuOpen && (
        <div className="relative z-[90] space-y-2 px-6 pb-4 md:hidden">
          {["Home", "About", "Services", "Gallery", "Contact"].map((text) => (
            <a key={text} href={`#${text.toLowerCase()}`} className="block text-gray-800 hover:text-pink-600 font-medium" onClick={toggleMenu}>{text}</a>
          ))}
          <button
            type="button"
            className="block w-full rounded-xl bg-emerald-600 px-4 py-3 text-center font-medium text-white"
            onClick={() => setBanquetsMenuOpen((value) => !value)}
            aria-expanded={banquetsMenuOpen}
            aria-haspopup="menu"
          >
            Banquets ▼
          </button>
          {banquetsMenuOpen ? (
            <div className="relative z-[100] space-y-2 rounded-xl border border-emerald-100 bg-emerald-50 p-2">
              {banquetMenuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="block min-h-[48px] touch-manipulation rounded-lg bg-white px-4 py-3 text-center font-medium text-slate-800"
                  onClick={(event) => openBanquetMenuItem(event, item.href)}
                  onTouchEnd={(event) => openBanquetMenuItem(event, item.href)}
                >
                  {item.label}
                </a>
              ))}
            </div>
          ) : null}
        </div>
      )}
    </header>
  );
};

// ---------------- HERO (Fixed Loop & WebP Extensions) ----------------
const Hero = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    let timeoutId = null;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth <= 768);
      }, 150);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  // ✅ Paths updated to .webp as per your folder
  const mobileImages = useMemo(() => ["/mobile_hero1.webp", "/mobile_hero2.webp", "/mobile_hero3.webp"], []);
  const desktopImages = useMemo(() => [
    "/1680x400_Banner-1_Decoration_Desktop_20241116_122654.webp",
    "/EXCLUSIVE_PremiumDecor_1680x400.webp",
    "/PreWedding_Banner_1680x400.webp",
  ], []);

  const slides = isMobile ? mobileImages : desktopImages;

  return (
    <section id="home" className="w-full m-0 p-0 -mt-16 -mb-24 sm:-mt-12 sm:-mb-16">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        interval={4000}
        stopOnHover={false}
        swipeable
        emulateTouch
      >
        {slides.map((src, i) => (
          <div key={i} className="w-full flex items-center justify-center bg-white" style={{ height: "400px" }}>
            <img
              src={src}
              alt={`Slide ${i + 1}`}
              className="h-full object-contain"
              style={{ width: "auto", maxWidth: "100%" }}
              onError={(e) => { e.target.src = "/images/Activities.webp"; }}
            />
          </div>
        ))}
      </Carousel>
    </section>
  );
};

// ---------------- HOME CARDS (Bina Chheda-Chhaadi) ----------------
export const categories = [
  { title: "Home Decor", image: "/images/home-decor-1.webp", link: "/subcategory/home-decor" },
  { title: "Cafe Decor", image: "/images/cafe-1.webp", link: "/subcategory/cafe-decor" },
  { title: "First Birthday Decorations", image: "/images/First-Birthday-Banner.webp", link: "/subcategory/first-birthday-decorations" },
  { title: "Wedding Events", image: "/images/Wedding-Events.webp", link: "/subcategory/wedding-events" },
  { title: "Activities", image: "/images/Activities.webp", link: "/subcategory/activities" },
  { title: "Theme Cakes", image: "/images/Theme-Cakes.webp", link: "/subcategory/theme-cakes" },
  { title: "Anniversary Decoration", image: "/images/Anniversary-Decoration.webp", link: "/subcategory/anniversary-decoration" },
  { title: "Welcome Baby Decoration", image: "/images/Welcome-Baby-Decoration.webp", link: "/subcategory/welcome-baby-decoration" },
  { title: "Baby Shower Decoration", image: "/images/Baby-Shower-Decoration.webp", link: "/subcategory/baby-shower-decoration" },
  { title: "Bride to Be Decoration", image: "/images/Bride-To-Be-Decoration.webp", link: "/subcategory/bride-to-be-decoration" },
  { title: "DecorZoom Store", image: "/images/Wall-Decoration.webp", link: "/store" },
  { title: "Return Gifts", image: "/images/Return-Gifts.webp", link: "/subcategory/return-gifts" },
  { title: "Birthday Photo Shoot", image: "/images/Birthday-Photo-Shoot.webp", link: "/subcategory/birthday-photo-shoot" },
  { title: "Theme Cake Tables", image: "/images/Theme-Cake-Tables.webp", link: "/subcategory/theme-cake-tables" },
];

export const MainApp = () => {
  const navigate = useNavigate();
  return (
    <div className="font-sans text-gray-800 scroll-smooth">
      <meta name="robots" content="noindex, nofollow" />
      <link rel="canonical" href="https://www.decorzoom.in/" />
      <Navbar />
      <Hero />
      <section id="services" className="pt-0 sm:pt-8 pb-10 px-4 bg-white">
        <h3 className="text-center text-3xl font-bold mb-6 text-black drop-shadow-lg mt-2 sm:mt-6">Our Services</h3>
        <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-5">
          {categories.map((cat, idx) => (
            <div key={idx} onClick={() => navigate(cat.link)} className="relative bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-transform transform hover:scale-105 cursor-pointer aspect-square">
              <img src="/images/ribbon.webp" alt="" className="absolute inset-0 w-full h-full object-cover rounded-3xl opacity-20" style={{ filter: "brightness(100%) blur(2px)" }} />
              <div className="relative w-full h-full flex items-center justify-center p-2">
                <img src={cat.image} alt={cat.title} className="h-[90%] w-[90%] object-contain rounded-2xl" />
              </div>
            </div>
          ))}
        </div>
      </section>
      <section id="gallery" className="bg-gray-100 py-10 px-4"><Gallery /></section>
      <section id="about" className="py-12 bg-gray-100 px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">About Us</h2>
        <p className="max-w-4xl mx-auto text-gray-700 text-lg">At DecorZoom, we've completed over 10,000+ decorations. We specialize in birthdays, weddings, and premium events.</p>
      </section>
      <TestimonialSlider />
      <section id="contact" className="py-12 bg-gray-100 px-4 text-center">
        <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
        <a href="tel:+918377982191" className="bg-green-500 text-white px-6 py-3 rounded-md shadow-md">📞 Call Us</a>
      </section>
      <section className="bg-white px-4 pb-10">
        <div className="max-w-5xl mx-auto border-t border-gray-200 pt-6 text-center">
          <h3 className="text-lg font-semibold text-gray-800">
            Popular Decoration Searches
          </h3>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm sm:text-base">
            {allSeoLandingLinks.map((item) => (
              <RouterLink key={item.to} to={item.to} className="text-green-600 hover:underline">
                {item.label}
              </RouterLink>
            ))}
          </div>
        </div>
      </section>
      <a href="https://wa.me/918377982191" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 left-6 bg-green-500 text-white rounded-full p-4 shadow-lg z-50 text-2xl"><FaWhatsapp /></a>
      <a href="tel:+918377982191" className="fixed bottom-6 right-6 bg-blue-500 text-white rounded-full p-4 shadow-lg z-50">📞</a>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePagePreview />} />
        <Route path="/home-preview" element={<Navigate to="/" replace />} />
        <Route path="/old-home-backup" element={<MainApp />} />
        <Route path="/subcategory/:subcategory" element={<SubcategoryPage />} />
        <Route path="/product/:slugAndId" element={<ProductDetailPage />} />
        <Route path="/store" element={<DecorZoomStore />} />
        <Route path="/store/product/:id" element={<StoreProductDetail />} />
        <Route
          path="/banquets"
          element={<BanquetsPage />}
        />
        <Route
          path="/banquets/:slug"
          element={<BanquetDetailPage />}
        />
        <Route
          path="/sample-public-banquet-detail"
          element={<SamplePublicBanquetDetailPage />}
        />
        <Route path="/owner-fill/:token" element={<OwnerFillFormPage />} />
        <Route path="/banquet-owner/login" element={<BanquetOwnerLoginPage />} />
        <Route
          path="/banquet-owner/dashboard"
          element={
            <BanquetOwnerProtectedRoute>
              <BanquetOwnerDashboardPage />
            </BanquetOwnerProtectedRoute>
          }
        />
        <Route
          path="/super-admin/banquet-owners"
          element={
            <SuperAdminProtectedRoute>
              <SuperAdminBanquetOwnersPage />
            </SuperAdminProtectedRoute>
          }
        />
        <Route
          path="/super-admin/banquet-review"
          element={
            <SuperAdminProtectedRoute>
              <SuperAdminBanquetReviewPage />
            </SuperAdminProtectedRoute>
          }
        />
        <Route
          path="/super-admin/quick-add-banquet"
          element={
            <SuperAdminProtectedRoute>
              <SuperAdminQuickAddBanquetPage />
            </SuperAdminProtectedRoute>
          }
        />
        <Route path="/birthday-decoration-in-delhi" element={<BirthdayDecorationDelhiPage />} />
        <Route path="/birthday-decoration-in-ghaziabad" element={<BirthdayDecorationGhaziabadPage />} />
        <Route path="/birthday-decoration-in-noida" element={<BirthdayDecorationNoidaPage />} />
        <Route path="/birthday-decoration-in-gurgaon" element={<BirthdayDecorationGurgaonPage />} />
        <Route path="/birthday-decoration-in-faridabad" element={<BirthdayDecorationFaridabadPage />} />
        <Route path="/first-birthday-decoration-in-delhi" element={<FirstBirthdayDecorationDelhiPage />} />
        <Route path="/baby-shower-decoration-in-delhi" element={<BabyShowerDecorationDelhiPage />} />
        <Route path="/balloon-decoration-in-delhi" element={<BalloonDecorationDelhiPage />} />
        <Route path="/balloon-decoration-in-ghaziabad" element={<BalloonDecorationGhaziabadPage />} />
        <Route path="/balloon-decoration-in-noida" element={<BalloonDecorationNoidaPage />} />
        <Route path="/balloon-decoration-in-gurgaon" element={<BalloonDecorationGurgaonPage />} />
        <Route path="/balloon-decoration-in-faridabad" element={<BalloonDecorationFaridabadPage />} />
        <Route path="/welcome-baby-decoration-in-delhi" element={<WelcomeBabyDecorationDelhiPage />} />
        <Route path="/welcome-baby-decoration-in-ghaziabad" element={<WelcomeBabyDecorationGhaziabadPage />} />
        <Route path="/welcome-baby-decoration-in-noida" element={<WelcomeBabyDecorationNoidaPage />} />
        <Route path="/anniversary-decoration-in-delhi" element={<AnniversaryDecorationDelhiPage />} />
        <Route path="/anniversary-decoration-in-ghaziabad" element={<AnniversaryDecorationGhaziabadPage />} />
        <Route path="/anniversary-decoration-in-noida" element={<AnniversaryDecorationNoidaPage />} />
        <Route path="/bride-to-be-decoration-in-delhi" element={<BrideToBeDecorationDelhiPage />} />
        <Route path="/jungle-theme-decoration-in-delhi" element={<JungleThemeDecorationDelhiPage />} />
        <Route path="/barbie-theme-decoration-in-delhi" element={<BarbieThemeDecorationDelhiPage />} />
        <Route path="/cocomelon-theme-decoration-in-delhi" element={<CocomelonThemeDecorationDelhiPage />} />
        <Route path="/boss-baby-theme-decoration-in-delhi" element={<BossBabyThemeDecorationDelhiPage />} />
        <Route path="/unicorn-theme-decoration-in-delhi" element={<UnicornThemeDecorationDelhiPage />} />
        <Route path="/butterfly-theme-decoration-in-delhi" element={<ButterflyThemeDecorationDelhiPage />} />
        <Route path="/spiderman-theme-decoration-in-delhi" element={<SpidermanThemeDecorationDelhiPage />} />
        <Route path="/mickey-mouse-theme-decoration-in-delhi" element={<MickeyMouseThemeDecorationDelhiPage />} />
        <Route path="/decoration-allahabad" element={<DecorationAllahabadPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </Router>
  );
}

export default App;
